<template>
  <main>
    <v-toolbar class="primary">
      <v-toolbar-title>
        <span style="color: #fff">
          {{ $t("notification") }}
        </span>
      </v-toolbar-title>
    </v-toolbar>
    <v-container>
      <formWrapper :validator="$v.form">
        <v-form @submit.prevent="onSendNotification">
          <v-row>
            <v-col cols="12" md="8" class="mx-auto">
              <v-row>
                <v-col cols="12" class="mx-auto py-0 my-0">
                  <form-group name="subject">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        outlined
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="form.subject"
                      ></v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="12" class="mx-auto py-0 my-0">
                  <form-group name="body">
                    <template slot-scope="{ attrs, listeners }">
                      <v-textarea
                        rows="5"
                        no-resize
                        outlined
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="form.body"
                      ></v-textarea>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="12" class="mx-auto py-0 my-0">
                  <v-btn
                    :loading="loadingBtn"
                    type="submit"
                    :disabled="$v.form.$invalid || form.ids.length === 0"
                    class="primary"
                    block
                    >{{ $t("send_message") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </formWrapper>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" md="8" class="mx-auto">
          <v-row>
            <template v-if="!toggle">
              <v-col cols="8">
                <v-autocomplete
                  v-model="camps"
                  :loading="loadingData"
                  :items="campsItems"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  outlined
                  :label="$t('camps')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" class="mx-auto">
                <v-btn
                  @click="handleFilter"
                  :disabled="camps.length === 0"
                  large
                  class="primary"
                  >{{ $t("filter") }}</v-btn
                >
              </v-col>
            </template>
            <template v-else>
              <v-col cols="8">
                <v-text-field
                  v-model="parent"
                  outlined
                  :label="$t('parent_id')"
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="mx-auto">
                <v-btn @click="handleAddParent" large class="primary">{{
                  $t("add")
                }}</v-btn>
              </v-col>
            </template>
            <v-col cols="2">
              <v-btn @click="onToggle" large class="success">
                {{ buttonText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      v-if="items.length > 0 && !toggle"
      :loading="tableLoading"
      hide-default-footer
      v-model="selected"
      :items-per-page="20"
      :headers="headers"
      show-select
      item-key="id"
      :items="items"
      :mobile-breakpoint="0"
    >
      <template v-slot:[`item.first_name`]="{ item }">
        {{ item.first_name }} {{ item.last_name }}
      </template>
    </v-data-table>
    <v-data-table
      v-if="toggle"
      hide-default-footer
      :headers="parentsHeaders"
      :items="items"
      :mobile-breakpoint="0"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">{{ item.parent_id }}</td>
          <td class="text-sm-center">
            <v-btn icon @click="onDelete(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <Pagination :pagination="pagination" />
  </main>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { IndexData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "Notification",
  components: {
    Pagination: () => import("@/components/Pagination"),
  },
  data() {
    return {
      loadingData: true,
      tableLoading: false,
      loadingBtn: false,
      campsItems: [],
      camps: [],
      parent: "",
      form: {
        subject: "",
        body: "",
        ids: [],
      },
      queries: {},
      pagination: {},
      items: [],
      selected: [],
      toggle: false,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    buttonText() {
      if (!this.toggle) {
        return this.$t("manual");
      } else {
        return this.$t("camps");
      }
    },
    headers() {
      const headers = [
        {
          text: this.$t("table.Select All"),
          align: "left",
          sortable: false,
          value: "select_all",
        },
        {
          text: this.$t("table.parent_name"),
          align: "center",
          sortable: false,
          value: "first_name",
        },
        {
          text: this.$t("table.phone"),
          align: "center",
          sortable: false,
          value: "mobile",
        },
        {
          text: this.$t("table.email"),
          align: "center",
          sortable: false,
          value: "email",
        },
      ];
      return headers;
    },
    parentsHeaders() {
      const headers = [
        {
          text: this.$t("table.parent_id"),
          align: "center",
          sortable: false,
          value: "parent_id",
        },
        {
          text: this.$t("table.action"),
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
      return headers;
    },
  },
  methods: {
    onToggle() {
      this.toggle = !this.toggle;
      this.items = [];
      this.camps = [];
      this.parent = "";
    },
    onDelete(index) {
      this.$delete(this.items, index);
    },
    handleAddParent() {
      this.items.push({ parent_id: this.parent });
      this.parent = "";
    },
    resetData() {
      this.$v.form.$reset();
      this.form = {
        subject: "",
        body: "",
        ids: [],
      };
      this.selected = [];
      this.campsItems = [];
      this.items = [];
      this.toggle = false;
    },
    onSendNotification() {
      this.loadingBtn = true;
      const formData = new FormData();
      formData.append("subject", this.form.subject);
      formData.append("body", this.form.body);
      this.form.ids.forEach((id, index) => {
        formData.append(`ids[${index}]`, id);
      });
      StoreData({ reqName: "content/send-notification", data: formData })
        .then(() => {
          this.resetData();
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    handleFilter() {
      this.queries = {};
      this.camps.forEach((camp, index) => {
        this.queries[`camp_ids[${index}]`] = camp;
      });
      this.getParents();
    },
    getList() {
      IndexData({ reqName: "reports/lists" }).then((res) => {
        const { all_camps } = res.data;
        this.campsItems = all_camps;

        this.loadingData = false;
      });
    },
    getParents() {
      this.tableLoading = true;
      IndexData({
        reqName: "content/parents",
        query: { ...this.queries },
      }).then((res) => {
        const { data, meta } = res.data;
        this.pagination = meta;
        this.items = data;
        this.selected = data;
        this.tableLoading = false;
      });
    },
  },
  watch: {
    selected: {
      handler(selectedValue) {
        if (!this.toggle) {
          this.form.ids = selectedValue.map((el) => el.id);
        }
      },
      immediate: true,
      deep: true,
    },
    items: {
      handler(itemsValue) {
        if (this.toggle) {
          this.form.ids = itemsValue.map((el) => el.parent_id);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      subject: {
        required,
        maxLength: maxLength(100),
      },
      body: {
        required,
        maxLength: maxLength(500),
      },
    },
  },
};
</script>

